export const migrationStatus = (migrationId: string) =>
  `kado.dashboard.migrationStatus.${migrationId}`;
